if (!customElements.get('organax-hero')) {
 customElements.define('organax-hero', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const on = (target,event,handler) => target.addEventListener(event,handler,{signal:this.abort.signal});
   this.slides = [...this.querySelectorAll('.organax-campaign-hero__slide')];
   this.dots = [...this.querySelectorAll('[data-hero-dot]')];
   this.current = Math.max(0,this.slides.findIndex(slide=>slide.classList.contains('is-active')));
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.motion.matches || !!window.Shopify?.designMode;
   this.focused = false;
   this.visible = true;
   this.interval = Math.max(5000,Number(this.dataset.interval)||8000);
   this.remaining = this.interval;
   on(this,'focusin',event=>{this.focused=event.target.matches(':focus-visible');this.scheduleAutoplay();});
   on(this,'focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.scheduleAutoplay();}});
   on(document,'visibilitychange',()=>this.scheduleAutoplay());
   on(this.motion,'change',()=>{if(this.motion.matches)this.paused=true;this.scheduleAutoplay();});
   this.visibilityObserver = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.scheduleAutoplay();},{threshold:0.1});
   this.visibilityObserver.observe(this);
   on(this,'click',event=>{
    if(this.swipeUntil && performance.now()<this.swipeUntil){event.preventDefault();return;}
    const dot=event.target.closest('[data-hero-dot]');
    if(dot) this.show(Number(dot.dataset.heroDot),true);
   });
   on(this,'pointerdown',event=>{if(event.pointerType==='touch')this.touchStart={x:event.clientX,y:event.clientY};});
   on(this,'pointerup',event=>{
    if(!this.touchStart)return;
    const dx=event.clientX-this.touchStart.x,dy=event.clientY-this.touchStart.y;this.touchStart=null;
    if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.4){this.swipeUntil=performance.now()+400;this.show(this.current+(dx<0?1:-1),true);}
   });
   on(this,'pointercancel',()=>{this.touchStart=null;});
   on(this,'keydown',event=>{
    if(!event.target.closest('[data-hero-controls]')||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    this.show(event.key==='Home'?0:event.key==='End'?this.slides.length-1:this.current+(event.key==='ArrowRight'?1:-1),true).then(()=>this.dots[this.current]?.focus({preventScroll:true}));
   });
   on(document,'shopify:block:select',event=>{
    const index=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));
    if(index>=0){this.paused=true;this.show(index,true);this.scheduleAutoplay();}
   });
   this.classList.add('is-ready');
   this.scheduleAutoplay();
  }
  disconnectedCallback(){this.abort?.abort();this.visibilityObserver?.disconnect();clearTimeout(this.transitionTimer);this.stopAutoplay();this.progressAnimation?.cancel();}
  stopAutoplay(){
   clearTimeout(this.autoplayTimer);
   if(this.autoplayStarted!=null){this.remaining=Math.max(0,this.remaining-(performance.now()-this.autoplayStarted));this.autoplayStarted=null;}
   this.progressAnimation?.pause();
  }
  prepareProgress(){
   if(this.progressAnimation||this.dataset.autoplay!=='true'||this.slides.length<2||this.paused)return;
   const fill=this.dots[this.current]?.querySelector('[data-hero-progress]');
   if(fill){this.progressAnimation=fill.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:this.interval,fill:'both',easing:'linear'});this.progressAnimation.pause();this.progressAnimation.currentTime=this.interval-this.remaining;}
  }
  scheduleAutoplay(){
   this.stopAutoplay();
   this.prepareProgress();
   if(this.dataset.autoplay!=='true'||this.slides.length<2||this.paused||this.focused||this.busy||!this.visible||document.hidden||!this.isConnected)return;
   this.autoplayStarted=performance.now();
   if(this.progressAnimation){this.progressAnimation.currentTime=this.interval-this.remaining;this.progressAnimation.play();}
   this.autoplayTimer=setTimeout(()=>this.show(this.current+1),this.remaining);
  }
  async show(requested,manual=false){
   if(!this.slides.length)return;
   const index=(requested+this.slides.length)%this.slides.length;
   if(this.busy||index===this.current||!this.isConnected)return;
   this.busy=true;
   this.stopAutoplay();
   const incoming=this.slides[index],outgoing=this.slides[this.current],stored=incoming.querySelector('template[data-hero-art]');
   if(stored)stored.replaceWith(document.importNode(stored.content,true));
   const backwards=requested<this.current;
   incoming.classList.toggle('is-before',backwards);incoming.hidden=false;incoming.inert=true;incoming.setAttribute('aria-hidden','true');
   void incoming.offsetWidth;
   let decodeTimer;
   try{await Promise.race([incoming.querySelector('.organax-campaign-hero__art img')?.decode(),new Promise(resolve=>{decodeTimer=setTimeout(resolve,5000);})]);}catch{/* Live copy remains usable if image loading fails. */}finally{clearTimeout(decodeTimer);}
   if(!this.isConnected){this.busy=false;return;}
   incoming.removeAttribute('aria-hidden');incoming.inert=false;outgoing.inert=true;
   void incoming.offsetWidth;
   incoming.classList.add('is-active');incoming.classList.remove('is-before');outgoing.classList.remove('is-active');outgoing.classList.toggle('is-before',!backwards);
   this.current=index;
   this.progressAnimation?.cancel();this.progressAnimation=null;this.remaining=this.interval;
   this.dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
   this.prepareProgress();
   if(manual)this.querySelector('[data-hero-status]').textContent='Slide '+(index+1)+' of '+this.slides.length+': '+incoming.dataset.label;
   this.transitionTimer=setTimeout(()=>{outgoing.hidden=true;outgoing.classList.remove('is-before');this.busy=false;this.scheduleAutoplay();},this.motion.matches?0:660);
  }
 });
}
